const skillsData = [
  {
    heading: "Technical Skills",
    skillsList: [
      "Full Stack Web Development",
      "Mobile Development [Native and Hybrid]",
      "Problem Solving",
    ],
  },
  {
    heading: "Tech Stacks",
    skillsList: [
      "MERN Stack[MongoDB, Express.js, React.js, Node.js]",
      "Flutter Mobile Development",
      " Native Android Development using Java and Kotlin",
    ],
  },
  {
    heading: "Programming languages",
    skillsList: ["Java", "javascript", "C++", "Python", "Dart", "Kotlin", "C"],
  },
  {
    heading: "Frontend",
    skillsList: [
      "Flutter",
      "React.js",
      "HTML5",
      "CSS3",
      "Material-UI",
      "JavaScript",
      "Bootstrap",
      "React Bootstrap",
    ],
  },
  { heading: "Backend", skillsList: ["Node.js", "Express.js", "Firebase"] },
  {
    heading: "Databases",
    skillsList: ["MongoDB", "SQL", "MySQL", "Firestore"],
  },
  {
    heading: "Hosting Platforms",
    skillsList: ["Heroku", "Netlify", "Firebase", "Github Pages"],
  },
  { heading: "Version Control", skillsList: ["git", "github"] },
];

export default skillsData;
